<ag-grid-angular
  style="width: 100%; height: 100%"
  class="ag-bcdfx intentStyled"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [toolPanelSuppressSideButtons]="true"
  [frameworkComponents]="frameworkComponents"
  enableColResize
  enableSorting
  singleClickEdit
  [stopEditingWhenGridLosesFocus]="true"
  (contextmenu)="handleClick($event)"
  multiSortKey="ctrl"
  [getRowHeight]="getRowHeight"
>
</ag-grid-angular>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
